import * as ActionTypes from '../../actions'
import {
    Action,
    ViolationsType
} from "../../types";

const defaultState = {
    isLoading: false,
    hasError: false,
    violationsHistory: {},
    recentViolationsArray: [],
    rawData: []
};

export default function(state: ViolationsType = defaultState, action: Action) {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.FETCH_VIOLATIONS_HISTORY:
            return {
                ...state,
                isLoading: true,
                hasError: false
            };
        case ActionTypes.FETCH_VIOLATIONS_HISTORY_SUCCESS: {
            const { violationsHistory, recentViolations } = payload;

            return {
                isLoading: false,
                hasError: false,
                violationsHistory,
                recentViolationsArray: recentViolations
            };
        }
        case ActionTypes.FETCH_VIOLATIONS_HISTORY_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasError: true
            };
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/violationHistory/violations.ts